import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const TranslationOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
`;

export const TranslationOptionsService = styled.div`
  margin-right: 1em;

  img {
    margin-top: 2px;
    height: 18px;
  }
`;

export const TranslationOptionsToggle = styled.div`
  button {
    cursor: pointer;
    text-decoration: underline;
    color: ${p => p.theme.text.callToAction};

    &:hover {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
`;

export const Reply = styled.div`
  background-color: ${p => p.theme.bg.secondary};
  padding: ${layout.measurements.spacing050};
  margin: ${layout.measurements.spacing050} 0;
  border-radius: 5px;
`;

export const ReplyName = styled.div`
  color: ${p => p.theme.text.secondary};
  padding-bottom: ${layout.measurements.spacing025};
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const ReplyDate = styled.span`
  float: right;

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const ReplyText = styled.div`
  white-space: pre-line;
`;

type TextLabelProps = {
  fullText?: boolean;
};

export const TextLabel = styled.div<TextLabelProps>(
  props => css`
    white-space: pre-line;
    word-break: break-word;
    font-weight: 400;
    color: ${p => p.theme.text.primary};
    max-height: 6ex;
    overflow: hidden;

    ${props.fullText &&
      css`
        max-height: none;
      `}
  `
);

export const Text = styled.p`
  max-width: 80ch;
`;

export const ReadMore = styled.button`
  color: ${p => p.theme.text.linkExternal};
  text-decoration: none;

  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
    cursor: pointer;
  }
`;

export const Dates = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.quaternary};
  margin-top: ${layout.measurements.spacing050};
`;

export const Divider = styled.span`
  margin-left: ${layout.measurements.spacing050};
  margin-right: ${layout.measurements.spacing050};
  font-size: ${layout.measurements.fontSizeSmall};
  font-style: normal;

  &::after {
    color: ${p => p.theme.text.quaternary};
    content: '•';
  }
`;
